module.exports = "/packs/step1-a1af3c88bd9c9849f7efc6aa073abd7e.png";